import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';


const BrandColorPicker = ({ label, value, onChange, description }) => {
  const [hexValue, setHexValue] = useState(value || '#2563EB');
  const [isValidHex, setIsValidHex] = useState(true);

  useEffect(() => {
    setHexValue(value || '#2563EB');
  }, [value]);

  const validateHex = (hex) => {
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return hexRegex?.test(hex);
  };

  const handleHexChange = (e) => {
    const newValue = e?.target?.value;
    setHexValue(newValue);
    
    if (validateHex(newValue)) {
      setIsValidHex(true);
      onChange(newValue);
    } else {
      setIsValidHex(false);
    }
  };

  const handleColorPickerChange = (e) => {
    const newValue = e?.target?.value;
    setHexValue(newValue);
    setIsValidHex(true);
    onChange(newValue);
  };

  const presetColors = [
    '#2563EB', '#DC2626', '#059669', '#D97706', '#7C3AED',
    '#EC4899', '#0EA5E9', '#10B981', '#F59E0B', '#8B5CF6'
  ];

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-text-primary mb-1">
          {label}
        </label>
        {description && (
          <p className="text-xs text-text-secondary mb-3">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-3">
        <div className="relative">
          <input
            type="color"
            value={hexValue}
            onChange={handleColorPickerChange}
            className="w-16 h-16 rounded-lg border-2 border-border cursor-pointer"
            style={{ backgroundColor: hexValue }}
          />
          <div className="absolute inset-0 rounded-lg pointer-events-none border-2 border-border" />
        </div>

        <div className="flex-1">
          <Input
            type="text"
            value={hexValue}
            onChange={handleHexChange}
            placeholder="#000000"
            error={!isValidHex ? 'Invalid hex color format' : ''}
            className="font-mono"
          />
        </div>
      </div>
      <div>
        <p className="text-xs font-medium text-text-secondary mb-2">Quick Select:</p>
        <div className="flex flex-wrap gap-2">
          {presetColors?.map((color) => (
            <button
              key={color}
              onClick={() => {
                setHexValue(color);
                setIsValidHex(true);
                onChange(color);
              }}
              className="w-10 h-10 rounded-lg border-2 border-border hover:border-primary transition-all duration-150 hover:scale-110"
              style={{ backgroundColor: color }}
              aria-label={`Select color ${color}`}
            />
          ))}
        </div>
      </div>
      <div className="p-3 bg-muted/50 rounded-lg">
        <div className="flex items-center gap-2">
          <div
            className="w-full h-12 rounded-lg border border-border"
            style={{ backgroundColor: hexValue }}
          />
        </div>
        <p className="text-xs text-text-secondary mt-2 text-center">
          Preview: This color will be used in your visualizer interface
        </p>
      </div>
    </div>
  );
};

export default BrandColorPicker;